// ============================================================================
// The signed-in person's own view settings, saved on their account.
// ----------------------------------------------------------------------------
// Peter, 2026-10-13: the Run Sheet view (columns, widths) "tied to the User.
// So that another user can set up their ideal view and it won't affect other
// users." Backend: GET/PATCH /api/auth/me/preferences/:key (routes/auth.js),
// stored in users.preferences and held to the signed-in person by the server.
//
// Both calls fail soft. A setting that cannot be read or saved leaves the page
// working with the copy this browser holds; nothing waits on the network.
// ============================================================================

import { apiFetch } from './data-service-api';

/** The Run Sheet column layout (src/services/run-sheet-columns.ts). */
export const RUN_SHEET_COLUMNS_PREFERENCE = 'runSheetColumns';

export type UserPreferenceRead = { ok: true; value: unknown } | { ok: false };

/** The saved value (null when the person never saved one), or { ok: false } when it could not be read. */
export async function fetchUserPreference(key: string): Promise<UserPreferenceRead> {
    try {
        const data = await apiFetch(`/auth/me/preferences/${encodeURIComponent(key)}`);
        return { ok: true, value: data?.value ?? null };
    } catch {
        return { ok: false };
    }
}

/** True when the server saved it. */
export async function saveUserPreference(key: string, value: unknown): Promise<boolean> {
    try {
        await apiFetch(`/auth/me/preferences/${encodeURIComponent(key)}`, {
            method: 'PATCH',
            body: JSON.stringify({ value }),
        });
        return true;
    } catch {
        return false;
    }
}
